// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceOutlinedSvg from "@fishx/icons-svg/es/asn/CustomerServiceOutlined";
import FishxIcon from '../components/FishxIcon';

var CustomerServiceOutlined = function CustomerServiceOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceOutlinedSvg
  }));
};

CustomerServiceOutlined.displayName = 'CustomerServiceOutlined';
export default React.forwardRef(CustomerServiceOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CustomerServiceOutlined.js
// module id = 2364
// module chunks = 0